export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("project.title")]: {
          field: "projectInfo.model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.equipment")]: {
          field: "auxiliaryCoolingEquipmentInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.brand")]: {
          field: "auxiliaryCoolingEquipmentInfo.brand",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.model")]: {
          field: "auxiliaryCoolingEquipmentInfo.model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.chip")]: {
          field: "auxiliaryCoolingEquipmentInfo.chip",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.width")]: {
          field: "auxiliaryCoolingEquipmentInfo.width",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.height")]: {
          field: "auxiliaryCoolingEquipmentInfo.height",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("auxiliaryCoolingEquipment.depth")]: {
          field: "auxiliaryCoolingEquipmentInfo.depth",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "auxiliaryCoolingEquipmentInfo.createdDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
        [this.$t("common.updatedDate")]: {
          field: "auxiliaryCoolingEquipmentInfo.updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
      };
    },
  },
};
